// Inward Stock Action Types
export const CONFIRMED_GET_INWARD_STOCK_LIST = "CONFIRMED_GET_INWARD_STOCK_LIST";
export const CONFIRMED_ADD_INWARD_STOCK = "CONFIRMED_ADD_INWARD_STOCK";
export const CONFIRMED_DELETE_INWARD_STOCK = "CONFIRMED_DELETE_INWARD_STOCK";
export const CONFIRMED_GET_INWARD_STOCK_DETAILS = "CONFIRMED_GET_INWARD_STOCK_DETAILS";

export const INWARD_STOCK_LOADING = "INWARD_STOCK_LOADING";
export const INWARD_STOCK_ERROR = "INWARD_STOCK_ERROR";

// Alias for backwards compatibility
export const ADD_INWARD_STOCK_REQUEST = "ADD_INWARD_STOCK_REQUEST";
export const ADD_INWARD_STOCK_SUCCESS = "ADD_INWARD_STOCK_SUCCESS";
export const ADD_INWARD_STOCK_FAIL = "ADD_INWARD_STOCK_FAIL";
export const GET_INWARD_STOCK_LIST_REQUEST = "GET_INWARD_STOCK_LIST_REQUEST";
export const GET_INWARD_STOCK_LIST_SUCCESS = "GET_INWARD_STOCK_LIST_SUCCESS";
export const GET_INWARD_STOCK_LIST_FAIL = "GET_INWARD_STOCK_LIST_FAIL";
export const GET_INWARD_STOCK_DETAILS_REQUEST = "GET_INWARD_STOCK_DETAILS_REQUEST";
export const GET_INWARD_STOCK_DETAILS_SUCCESS = "GET_INWARD_STOCK_DETAILS_SUCCESS";
export const GET_INWARD_STOCK_DETAILS_FAIL = "GET_INWARD_STOCK_DETAILS_FAIL";